import classes from "./CartProduct.module.css";
import { useContext, useState, useEffect } from "react";
import { CartContext } from "./CartContext";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { blurContext } from "./BlurContext";

function CartProduct(props) {
	const Loadproduct = useContext(CartContext);

	//state for launching modal window
	const [showModal, setShowModal] = useState(false);
	const showModalfunc = () => {
		setShowModal(true);
		changeBlurState(true);
	};
	const hideModalfunc = () => {
		setShowModal(false);
		changeBlurState(false);
	};

	//for navigating the app
	const navigate = useNavigate("");

	//import blur context
	const { changeBlurState } = useContext(blurContext);

	// effect to listen for press of backward or forward buttons in the browser to change blur state to false
	useEffect(() => {
		return () =>
			window.addEventListener("popstate", () => changeBlurState(false));
	}, [changeBlurState]);

	return (
		<>
			<div
				className={classes.card}
				onClick={showModalfunc}
				title="Click to expand"
			>
				<div className={classes.image}>
					<img
						src={props.itemImg[0]}
						alt={props.itemName}
						width={120}
						height={160}
						style={{ borderRadius: "4px" }}
					/>
				</div>
				<div className={classes.productDetails}>
					<div>
						<Link
							to={"/products/" + props.id}
							style={{ color: "black" }}
							onClick={(event) => event.stopPropagation()}
						>
							<p style={{ fontWeight: "500" }}>
								{props.itemName}
							</p>
						</Link>
						<div className={classes.sizeQty}>
							<p>Size: {props.size}</p>
							<p>Quantity: {props.quantity}</p>
						</div>
					</div>

					<div className={classes.price}>
						<p>Base Price: ${props.itemPrice}</p>
						<p>
							Total Price:{" "}
							{`$${props.itemPrice * props.quantity}`}
						</p>
					</div>

					<div>
						<Button
							onClick={(event) => {
								event.stopPropagation();
								Loadproduct.removeProduct(props.id, props.sku);
							}}
							className="mb-3 rounded-1"
							variant="success"
						>
							Remove Product
						</Button>
					</div>
				</div>
			</div>

			<Modal show={showModal} onHide={hideModalfunc} size="lg" centered>
				<Modal.Header closeButton>
					<Modal.Title>{props.itemName}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div style={{ display: "flex" }}>
						<div
							style={{
								width: "45%",
								marginLeft: "1rem",
								marginRight: "1rem",
								marginTop: "1rem",
								fontSize: "1rem",
							}}
						>
							<p>Product Name: {props.itemName}</p>
							<p>Base Price: ${props.itemPrice}</p>
							<p>Quantity: {props.quantity}</p>
							<p>Size: {props.size}</p>
							<p>
								Total Price:{" "}
								{`$${props.itemPrice * props.quantity}`}
							</p>
						</div>
						<div
							style={{
								width: "55%",
								borderRadius: "12px",
								marginTop: "1rem",
								marginBottom: "1rem",
								marginLeft: "10%",
							}}
						>
							<img
								src={props.itemImg[0]}
								alt={props.itemName}
								style={{
									borderRadius: "8px",
									width: "80%",
									height: "100%",
								}}
							/>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="success"
						onClick={() => {
							navigate(`/products/${props.id}`);
							changeBlurState(false);
						}}
						className="rounded-1"
					>
						View Product{" "}
						<img
							src="./images/external-link.png"
							alt="view-product"
							width={20}
						/>
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
}
export default CartProduct;
